import { Component, OnInit, Input, Output, EventEmitter, HostListener, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';
import {SeoService} from '../../services/seo.service';
import { element } from 'protractor';
import counterUp from 'counterup2';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  public stream = 'https://player.vimeo.com/external/597805071.m3u8?s=51adbefe89385966dd8beb2952b373f5414c1fdf&logging=false';
  public stream2 ='https://player.vimeo.com/external/708795944.m3u8?s=e6a9b58b81e0c3b314609fe596d21e10afe259e0&logging=false';
  public itsMobile = false;
  public video1:boolean;
  public video2:boolean;
  public video3:boolean;
  public video4:boolean;
  public video5:boolean;
  public video6:boolean;
  public video7:boolean;
  public video8:boolean;
  public video9:boolean;
  public path: string;
  // public position:boolean = true;
  public active: any;
  public hide: any;

  public fixed:boolean;
  public hidden:boolean;
  public hiddenTop:boolean;

  constructor( private sanitizer: DomSanitizer,private title: Title, private seo: SeoService, private route: ActivatedRoute,location: Location, router: Router, private el: ElementRef ) {
    router.events.subscribe((val) => {
      this.path = location.path();
      this.path = this.path.substring(1);
    });
  }

  @ViewChild('counter') counter: ElementRef;
  callback = (entries) => {
    // const counterUp = counterUp.default
    entries.forEach((entry) => {
      const el = entry.target;
      let previousY = 0
      let previousRatio = 0
      //  console.log('isIntersecting :', entry.target.getBoundingClientRect());
      if (entry.isIntersecting && !el.classList.contains('is-visible')) {
        counterUp(el, {
          duration: 1000
        });
      }
      const currentY = entry.boundingClientRect.y
    const currentRatio = entry.intersectionRatio
    const isIntersecting = entry.isIntersecting

    // Scrolling down/up
    if (currentY < previousY) {
      console.log("Scrolling down")
      el.classList.add( 'is-visible' )
    }
    else if (currentY > previousY && isIntersecting) {
      el.classList.remove( 'is-visible' )
    }

    previousY = currentY
    previousRatio = currentRatio
    });
  };



  ngOnInit(): void {
    const theTitle = 'gennius.xyz - Building Human-to-Human technologies';
    this.title.setTitle(theTitle);

    this.seo.generateTags({
      title: theTitle, //'cryptMi: the first dynamic card that blends rewards, crypto & local currencies.',
      keyword: 'rewards, cryptocurrencies, crypto, cashback, points, miles, digital card, digital payment, loyalty rewards, redemptions, digital assets, bank cards, bank directs, smart payments, virtual card, metaverse, NFT',
      // tslint:disable-next-line:max-line-length
      description: "Empowering rewards and Web3 platforms to create superior user experiences and bring digital engagement and loyalty to new levels.",
      image: 'https://gennius.xyz/assets/img/gennius/share-gennius.jpg'
    });

    if (this.verifyMobile()) {
      this.itsMobile = true;
    }

    // Loads the images and videos
    this.loadAssets();

    const el1 = document.querySelector('.counter-1');
    const el2 = document.querySelector('.counter-2');
    const el3 = document.querySelector('.counter-3');
    const el4 = document.querySelector('.counter-4');
    const el5 = document.querySelector('.counter-5');
    const el6 = document.querySelector('.counter-6');
    const IO = new IntersectionObserver(this.callback, { threshold: 1 });
    IO.observe(el1);
    IO.observe(el2);
    IO.observe(el3);
    IO.observe(el4);
    IO.observe(el5);
    IO.observe(el6);

  }


  loadAssets() {
    let elementsSrc = document.querySelectorAll('[src-tmp]');

    elementsSrc.forEach((theElement: any) => {
      if (theElement.src != undefined){
        theElement.src = theElement.getAttribute('src-tmp');
        theElement.removeAttribute('src-tmp');
      }
    });

    // $.each(, function (index, theElement) {
    //
    // });
  }

  // @HostListener('body:scroll', ['$event'])
  // onScrollingEvent($event): void {
  //   this.loadAssets();
  //   let scrollOffset = $event.target.scrollTop;
  //   if (scrollOffset > 0) {
  //     this.position = true;
  //   } else {
  //     this.position = false;
  //   }
  // }

  topPage() {
    window.scrollTo(0, 0);
  }

  verifyMobile(): any {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  options = {
    enableScrollSpy: true
  };


  SlideOptions = {
    items: 1,
    dots: true,
    nav: false,
    margin: 0,
    stagePadding: 0,
    autoHeight: true,
    loop:true,
    autoplay:false,
  };

  openVideo(number:any){
    this.loadAssets();
    this["video" + number] = true;
    if(number == '1'){
      const video = this.el.nativeElement.querySelector('video.main-video');
      video.play();
    }else if(number == '2'){
      const video = this.el.nativeElement.querySelector('video.video-two');
      video.play();
    }
    else if(number == '4'){
      const video = this.el.nativeElement.querySelector('video.video-nft');
      video.play();
    }
    else if(number == '5'){
      const video = this.el.nativeElement.querySelector('video.video-metaverse');
      video.play();
    }
    else if(number == '6'){
      const video = this.el.nativeElement.querySelector('video.video-travel');
      video.play();
    }
    else if(number == '7'){
      const video = this.el.nativeElement.querySelector('video.video-card');
      video.play();
    }
    else if(number == '8'){
      const video = this.el.nativeElement.querySelector('video.video-bank-card');
      video.play();
    }
    else if(number == '9'){
      const video = this.el.nativeElement.querySelector('video.video-shop');
      video.play();
    }
  }

  closeVideo(number:any){
    this["video" + number] = false;
    if(number == '1'){
      const video = this.el.nativeElement.querySelector('video.main-video');
      video.pause();
    }else if(number == '2'){
      const video = this.el.nativeElement.querySelector('video.video-two');
      video.pause();
    }
    else if(number == '4'){
      const video = this.el.nativeElement.querySelector('video.video-nft');
      video.pause();
    }
    else if(number == '5'){
      const video = this.el.nativeElement.querySelector('video.video-metaverse');
      video.pause();
    }
    else if(number == '6'){
      const video = this.el.nativeElement.querySelector('video.video-travel');
      video.pause();
    }
    else if(number == '7'){
      const video = this.el.nativeElement.querySelector('video.video-card');
      video.pause();
    }
    else if(number == '8'){
      const video = this.el.nativeElement.querySelector('video.video-bank-card');
      video.pause();
    }
    else if(number == '9'){
      const video = this.el.nativeElement.querySelector('video.video-bank-card');
      video.pause();
    }
  }

    iFrameUrl: SafeResourceUrl;
    displayIFrame = false;
    onOpenIframe() : void{
      this.iFrameUrl = {};
      this.displayIFrame = true;
    }





  // showContent(number: any) {
  //   this.active = true;
  //   this["video" + number] = !this["video" + number];
  //   const video = this.el.nativeElement.querySelector('.content-video');
  //   video.pause();
  //   if (number === '1') {
  //     this["video" + '2'] = false;
  //     this["video" + '3'] = false;
  //     this.hide = false;
  //     video.play();
  //   } else if (number === '2') {
  //     this["video" + '1'] = false;
  //     this["video" + '3'] = false;
  //     this.hide = false;
  //   } else if (number === '3') {
  //     this["video" + '1'] = false;
  //     this["video" + '2'] = false;
  //     this.hide = true;
  //   }
  //   if (this["video" + '1'] == false && this["video" + '2'] == false && this["video" + '3'] == false) {
  //     this.active = false;
  //     video.pause();
  //   }
  // }

  receiveMessage($event) {
    this.hidden = $event;
  }

  getMessage($event) {
    this.hiddenTop = $event;
  }


}


